import { useTranslation } from 'react-i18next'

import { MaterialSymbol } from '../../../../components/MaterialSymbol'
import { getFuelSavings, getTreesSavings, getWasteSavings } from '../utils'

import { useWidgetStyles } from './styles'
import { WidgetContainer } from './WidgetContainer'

export const Co2SavingsWidget = ({ co2savings }: { co2savings?: number }) => {
  const classes = useWidgetStyles()
  const { t } = useTranslation()

  return (
    <WidgetContainer className={classes.co2savingsContainer}>
      <div className={classes.line}>
        <div className={classes.textContainer}>
          <MaterialSymbol
            className={classes.saveIcons}
            name="energy_program_saving"
            settings={{ fill: true, size: 22 }}
          />
          <span>{t('rooftop_planner.co2_saved')}</span>
        </div>
        <span className={classes.dataCell}>
          {co2savings ? `${parseFloat(co2savings.toFixed(2))} t` : '-'}
        </span>
      </div>

      <div className={classes.equivalentTo}>
        {t('rooftop_planner.equivalent_to')}
      </div>

      <div className={classes.line}>
        <div className={classes.textContainer}>
          <MaterialSymbol
            className={classes.saveIcons}
            name="forest"
            settings={{ fill: true, size: 22 }}
          />
          <span>{t('rooftop_planner.forest_area')}</span>
        </div>
        <span className={classes.dataCell}>
          {co2savings
            ? getTreesSavings(parseFloat(co2savings.toFixed(2)))
            : '-'}
        </span>
      </div>

      <div className={classes.line}>
        <div className={classes.textContainer}>
          <MaterialSymbol
            className={classes.saveIcons}
            name="local_gas_station"
            settings={{ fill: true, size: 22 }}
          />
          <span>{t('rooftop_planner.fuel')}</span>
        </div>
        <span className={classes.dataCell}>
          {co2savings
            ? `${getFuelSavings(parseFloat(co2savings.toFixed(2)))} l`
            : '-'}
        </span>
      </div>
      <div className={classes.line}>
        <div className={classes.textContainer}>
          <MaterialSymbol
            className={classes.saveIcons}
            name="recycling"
            settings={{ fill: true, size: 22 }}
          />
          <span>{t('rooftop_planner.waste_recycled')}</span>
        </div>
        <span className={classes.dataCell}>
          {co2savings
            ? `${getWasteSavings(parseFloat(co2savings.toFixed(2)))} kg`
            : '-'}
        </span>
      </div>
    </WidgetContainer>
  )
}
